import { ActivityPurchaseModel } from 'api-hooks/order/activity';
import { ActivitySaleModel } from 'api-hooks/sale/activity';
import { MainAdditionalFormType } from 'legacy-modules/order/ticket-order/components/form-type';
import * as Yup from 'yup';

export const ActivityPurchaseAddOnsItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    description: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //additional information
    guestName: Yup.string().default(''),
    customId: Yup.string(),
  });

export const ActivityPurchaseGuestDetailsFormSchema = () =>
  Yup.object({
    activityId: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    qty: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    totalPrice: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    description: Yup.string().default(''),
    type: Yup.string().default(''),
    date: Yup.date().default(new Date()),

    //additional information
    customId: Yup.string(),
    activityName: Yup.string().default(''),
  });

export const ActivityPurchaseGuestFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    activityPurchaseGuestDetails: Yup.array(
      ActivityPurchaseGuestDetailsFormSchema(),
    ).default([]),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const ActivityPurchaseItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    isGroupedPrice: Yup.bool().default(false),
    activityPurchaseGuests: Yup.array(
      ActivityPurchaseGuestFormSchema(),
    ).default([]),
    activityPurchaseAddOns: Yup.array(
      ActivityPurchaseAddOnsItemFormSchema(),
    ).default([]),

    //additional information
    customId: Yup.string(),
  });

export const ActivityPurchaseFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    type: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    tourRefId: Yup.string().default(''),
    invoiceRefId: Yup.string().default(''),
    agentId: Yup.string().default(''),
    paymentChannelId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    commission: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    activityPurchases: Yup.array(ActivityPurchaseItemFormSchema()).default([]),
  });

export type ActivityPurchaseAddOnsItemFormType = Yup.InferType<
  ReturnType<typeof ActivityPurchaseAddOnsItemFormSchema>
>;

export type ActivityPurchaseGuestDetailsFormType = Yup.InferType<
  ReturnType<typeof ActivityPurchaseGuestDetailsFormSchema>
>;

export type ActivityPurchaseGuestsFormType = Yup.InferType<
  ReturnType<typeof ActivityPurchaseGuestFormSchema>
>;
export type ActivityPurchasesItemFormType = Yup.InferType<
  ReturnType<typeof ActivityPurchaseItemFormSchema>
>;

export type ActivityPurchaseFormType = Yup.InferType<
  ReturnType<typeof ActivityPurchaseFormSchema>
> &
  MainAdditionalFormType & {
    activitySale?: ActivitySaleModel;
    activityPurchase?: ActivityPurchaseModel;
  };
